
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/defCreate",
      function () {
        return require("private-next-pages/form/defCreate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/defCreate"])
      });
    }
  